import Component from '../abstracts/Component';
import { gregorian } from '@pacote/computus';

/**
 Date picker component
 */
export default class DatePickerComponent extends Component {

  get SELECTORS () {
    return {
      datepicker: '.js-datepicker',
      returnOrderProceed: '.js-proceed-to-confirm',
    };
  }

  dateFormatByCountry() {
    // Korea: Y-M-D , US : M-D-Y, EU: D-M-Y
    let currentCountry = document.body.dataset.website.toLowerCase();
    let dateFormat = '';

    switch (currentCountry) {
      case 'us':
        dateFormat = 'm-d-Y';
        break;
      default:
        dateFormat = 'd-m-Y';
    }

    return dateFormat;
  }

  today() {
    let todayTime = new Date();
    let dd = todayTime.getDate();
    let mm = todayTime.getMonth() + 1;
    let yyyy = todayTime.getFullYear();

    if (dd < 10) {
      dd = '0' + dd;
    }

    if (mm < 10) {
      mm = '0' + mm;
    }

    let format = this.dateFormatByCountry();
    let today = '';

    switch (format) {
      case 'd-m-Y':
        today = dd + '/' + mm + '/' + yyyy;
        break;
      case 'm-d-Y':
        today = mm + '/' + dd + '/' + yyyy;
        break;
      case 'Y-m-d':
        today = yyyy + '/' + mm + '/' + dd;
        break;
      default:
        today = dd + '/' + mm + '/' + yyyy;
    }

    return today;
  }

  initDatepicker(flatpickr, localization, check) {
    let ctx = this;
    let _dateFormat = ctx.dateFormatByCountry();

    $(check).each(function() {

      let _this = $(this);
      let mindate = null;
      let maxdate = null;
      const disableweekends = $(this).data('disableweekends') || false;
      mindate = Date.parse($(this).data('mindate'));
      maxdate = Date.parse($(this).data('maxdate'));
      const showCalendar = $(this).data('showCalendar');

      if (disableweekends) {

        var isGLSOrder = document.getElementById("isGLSOrder");
        var country = $("body").data("website");
        var isCountryIT = country != null && country.toLowerCase() === 'it';
        if ((typeof(isGLSOrder) != 'undefined' && isGLSOrder != null && isGLSOrder.value === 'true') || isCountryIT) {
          var currentEasterDate = gregorian(new Date().getFullYear());
          var currentEasterMondayDate = new Date(currentEasterDate);
          currentEasterMondayDate.setDate(currentEasterDate.getDate() + 1);
          var currentEasterMonday = (currentEasterMondayDate.getDate()) + '/' + (currentEasterMondayDate.getMonth() + 1);
        }
        _this.flatpickr({
          disableMobile: 'true',
          dateFormat: "Y-m-d",
          minDate: mindate,
          maxDate: maxdate,
          allowInput: !showCalendar,
          clickOpens: showCalendar,
          altInput: true,
          altFormat: _dateFormat,
          onChange: function(dateObj, dateStr, instance) {
            if ($('input[name=hourpick]').is(':checked')) {
              $(ctx.SELECTORS.returnOrderProceed).removeClass('disabled');
            }
          },
          animate: false,
          disable: [
            function(date) {
              var exclude = ['1/1', '6/1', '25/4', '1/5', '2/6', '15/8', '1/11', '8/12', '25/12', '26/12', currentEasterMonday];
              var d = date.getDate();
              var m = date.getMonth();
              var dayExclude = d + '/' + (m+1);
              return (date.getDay() === 6 || date.getDay() === 0 || ~$.inArray(dayExclude, exclude));
            }
          ],
          locale: localization
        });
        const hourpickSelected = $('#hourpickSelected').val();
        if (hourpickSelected) {
          $('#hourpick').val(hourpickSelected);
        }
      } else {
        _this.flatpickr({
          disableMobile: 'true',
          dateFormat: "Y-m-d",
          altInput: true,
          altFormat: _dateFormat,
          minDate: mindate,
          maxDate: maxdate,
          allowInput: !showCalendar,
          locale: localization,
          clickOpens: showCalendar,
        });
      }
    });
  }

  constructor(htmlEl) {
    super(htmlEl);
  }

  getLocalization(lang) {
    switch (lang) {
      case 'en':
        return 'default';
      default:
        return lang;
    }
  }

  render() {
    this.log('Rendering...');
    let lang = this.getLocalization($('html').attr('lang'));
    this.moduleLoader.loadFlatpickr(module => {
      this.moduleLoader.loadFlatpickrLocale(lang, (localization) => {
          this.initDatepicker(module.default, lang, this.SELECTORS.datepicker);
          this.bindEvents(module.default, lang, this.SELECTORS)
          this.setMaxLengthBirthDatePicker();
          this.setAriaLabel();
        },
        err => console.warn('cant load flatpickr')
      );
    });
  }

  bindEvents(moduled,lang,selectors) {
    const ctx = this;

    this.$on(this.$customEvents.PAGE_LAYOUT_EVENTS.changed, ({event, payload}) => {
      ctx.log('Setup for html edit');
      ctx.initDatepicker(moduled, lang, selectors.datepicker);
    });
  }

  setMaxLengthBirthDatePicker() {
    $(this.SELECTORS.datepicker).attr('maxlength', '10');
  }

  setAriaLabel() {
    $(this.SELECTORS.datepicker).attr('aria-labelledby', this.$component.dataset.customLabel);
  }
}
